import { isSupportedYear } from '@shared/helpers';
import { Emojis, LocationCls, ValueCls } from 'app/constants';
import { useAppSelector } from 'app/hooks';
import { getSelectedYear } from 'app/slices/GamesSlice';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/Routes';

/**
 * Index route for Comparison - redirects to current season.
 *
 * @return {JSX.Element} Empty component (performs navigation)
 */
export const ComparisonIndexRoute: React.FC = () => {
  const navigate = useNavigate();
  const selectedYear = useAppSelector(getSelectedYear);

  useEffect(() => {
    if (isSupportedYear(selectedYear)) {
      const msg = `${Emojis.eyes} %c ComparisonIndexRoute %c, year %c ${selectedYear} %c`;
      console.log(msg, LocationCls, '', ValueCls, '');
      navigate(`${AppRoutes.Comparison}/${selectedYear}`, { replace: false });
    }
  }, [selectedYear, navigate]);

  return <></>;
};

export default ComparisonIndexRoute;
